import { inject, observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";

const styles = theme => ({
  dialogContent: {
    marginBottom: 25
  }
});

class IssueDialog extends React.Component {
  render() {
    const { classes, issueDialogStore } = this.props;

    return (
      <div>
        <Dialog
          open={issueDialogStore.isOpen}
          onClose={() => issueDialogStore.clear()}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Report Issue with Clip
          </DialogTitle>
          <DialogContent>
            <DialogContentText className={classes.dialogContent}>
              Does the clip need to be recut? Is the play improperly tagged? For
              any issue with this clip, submit this brief report, and we will
              fix it as soon as possible.
            </DialogContentText>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Choose Issue Category (if possible)
              </FormLabel>
              <FormGroup>
                {issueDialogStore.checkboxes.map(c => (
                  <FormControlLabel
                    key={c.value}
                    control={
                      <Checkbox
                        checked={c.isChecked}
                        onChange={(e, checked) => (c.isChecked = checked)}
                        value={c.value}
                      />
                    }
                    label={c.label}
                  />
                ))}
              </FormGroup>
            </FormControl>
            <TextField
              autoFocus
              margin="dense"
              id="comment"
              label="Comment"
              fullWidth
              multiline
              value={issueDialogStore.comment}
              onChange={e => (issueDialogStore.comment = e.target.value)}
              rows={3}
              rowsMax={5}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => issueDialogStore.clear()} color="primary">
              Cancel
            </Button>
            <Button onClick={() => issueDialogStore.submit()} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("issueDialogStore")(
  withStyles(styles)(observer(IssueDialog))
);



// WEBPACK FOOTER //
// ./src/components/IssueDialog.js